export default ($axios) => {
  return {
    postInquiries: async (data) => {
      return await $axios.post('/inquiries', data)
    },
  }
}